/* eslint react/no-danger: 0 */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { useShoppingCartContext } from '../../contexts/shoppingCart';
import IMG from '../img';

const useStyles = makeStyles((theme) => ({
  priceSummary: {
    display: 'flex',
    justifyContent: 'space-arround',
    padding: theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'column',
      marginLeft: 'auto',
      padding: theme.spacing(1, 0),
      width: 200,
    },
  },
  priceContainer: {
    alignSelf: 'center',
    flexBasis: 0,
    flexGrow: 1,
    fontSize: 13,
    fontWeight: 'bold',
    textAlign: 'right',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      display: 'flex',
      fontSize: 16,
      justifyContent: 'space-between',
      marginTop: theme.spacing(1),
      width: '100%',
    },
  },
}));

const Item = ({ data }) => {
  const {
    key = '',
    amount = 1,
    name = '',
    provider = '',
    orderId = '',
    specs = [],
    images = [],
    sellPrice = 0,
    price = 0,
  } = data || {};

  const totalPrice = (sellPrice || price) * amount;

  return (
    <Box display="flex" my={1} key={`${key}_${amount}_${JSON.stringify(specs)}`}>
      <Hidden only="xs">
        <IMG
          style={{
            display: 'inline-block',
            height: '200px',
            marginRight: '10px',
            objectFit: 'cover',
            verticalAlign: 'top',
            width: '200px',
          }}
          src={images[0] || ''}
          alt=""
        />
      </Hidden>
      <Box bgcolor="rgb(242, 242, 242)" p={3} flex="1" color="rgb(83,83,83)">
        <Box fontWeight="bold" color="black">訂單明細（已完成結帳）</Box>
        <Hidden only="sm"><hr /></Hidden>
        <Grid container spacing={1} style={{ marginTop: 8 }}>
          <Grid container item spacing={1} style={{ justifyContent: 'space-between' }}>
            <Grid item>商品名稱</Grid>
            <Grid item>{`【${provider}】${name}`}</Grid>
          </Grid>
          {
            (specs || []).map(({ name: specName, value }) => (
              <Grid container item spacing={1} style={{ justifyContent: 'space-between' }} key={specName}>
                <Grid item>{specName}</Grid>
                <Grid item>{value}</Grid>
              </Grid>
            ))
          }
          <Grid container item spacing={1} style={{ justifyContent: 'space-between' }}>
            <Grid item>訂購數量：</Grid>
            <Grid item>{amount}</Grid>
          </Grid>
          <Grid container item spacing={1} style={{ justifyContent: 'space-between' }}>
            <Grid item>金額總計：</Grid>
            <Grid item>{totalPrice.toLocaleString('en-US')}</Grid>
          </Grid>
          <Grid container item spacing={1} style={{ justifyContent: 'space-between' }}>
            <Grid item>訂單編號：</Grid>
            <Grid item>{orderId}</Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const Receipt = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isInDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const { shoppingCart, removeItem } = useShoppingCartContext();
  const history = useHistory();
  const {
    orderId,
    items,
    urlToGo,
    totalPrice,
  } = history?.location?.state || {};

  useEffect(() => {
    if (isEmpty(items)) history.replace('/');
    (items || []).forEach((item) => {
      shoppingCart.forEach((shoppingCartItem) => {
        if (
          shoppingCartItem.key === item.key
          && shoppingCartItem.provider === item.provider
          && (
            (shoppingCartItem.specs || []).map((spec) => spec.key).sort().join('-')
            === (item.specs || []).map((spec) => spec.key).sort().join('-')
          )
        ) {
          removeItem(shoppingCartItem);
        }
      });
    });
  }, [items, history, removeItem, shoppingCart]);

  const receiptHeader = (
    <>
      <Hidden only="xs">
        <Box fontWeight="fontWeightBold" fontSize="20px" pl="210px">感謝您已完成訂購</Box>
        <Box pl="210px">以下為您的訂購資訊</Box>
      </Hidden>
      <Hidden smUp>
        <Box position="relative">
          <Box
            position="absolute"
            width={1}
            bottom={60}
          >
            <Grid container direction="column" justify="center" spacing={1}>
              <Grid item>
                <Box
                  color="primary.main"
                  fontSize="h5.fontSize"
                  fontWeight="fontWeightBold"
                  textAlign="center"
                >
                  感謝您已完成訂購
                </Box>
              </Grid>
              <Grid item>
                <Box
                  color="common.white"
                  fontSize="body1.fontSize"
                  fontWeight="fontWeightBold"
                  textAlign="center"
                >
                  以下為您的訂購資訊
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Hidden>
    </>
  );

  const receiptFooter = (
    <Hidden smUp>
      <Box
        width={1}
        position="fixed"
        left={0}
        bottom={0}
        bgcolor="common.white"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}
      >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => history.push(urlToGo || '/')}
        >
          <Box
            py={2}
            fontSize="body1.fontSize"
            fontWeight="fontWeightBold"
          >
            訂購完成
          </Box>
        </Button>
      </Box>
    </Hidden>
  );

  return (
    <Box
      minHeight="calc(100vh - 100px)"
      bgcolor={isInDesktop ? 'white' : 'rgb(242, 242, 242)'}
      pb={isInDesktop ? 1 : 5}
      textAlign="left"
    >
      {receiptHeader}
      <Box
        py={2}
        mb={2}
      >
        { (items || []).map((data) => (
          <Item
            data={{
              ...data,
              orderId,
            }}
            key={data.productId}
          />
        ))}
        <div className={classes.priceSummary}>
          <div className={classes.priceContainer}>
            <div>
              支付總金額
            </div>
            <div style={{ color: '#a80000' }}>
              {`$${totalPrice.toLocaleString('en-US')}`}
            </div>
          </div>
        </div>
      </Box>
      {receiptFooter}
    </Box>
  );
};

export default Receipt;
